<div class="pagination-container">
  <button
    class="pagination-button"
    (click)="mudarPagina(-1)"
    [disabled]="paginacao.page === paginacao.pageFirst"
    *ngIf="paginacao.page > 1"
    type="button"
  >
    Anterior
  </button>

  <ng-container *ngFor="let page of paginasVisiveis">
    <button
      class="pagination-number"
      [ngClass]="{ active: paginacao.page === page }"
      (click)="paginaMudada.emit(page)"
      type="button"
    >
      {{ page }}
    </button>
  </ng-container>

  <button
    class="pagination-button"
    (click)="mudarPagina(1)"
    [disabled]="paginacao.page === paginacao.pageLast"
    type="button"
  >
    Próximo
  </button>
</div>
